import { logger as E } from "../../shared-lib/index.js";
import { BANNERS_DISABLED_MESSAGE as v } from "../common/constants.js";
import r from "../managers/braze-instance.js";
import i from "./banner-provider-factory.js";
import { getBannerIfNotExpired as y } from "./get-banner.js";
export function getAllBanners() {
  if (!r.rr()) return;
  var n = {},
    o = r.l();
  if (!1 === (null == o ? void 0 : o.Dt()) && E.error(v), !(null == o ? void 0 : o.Dt())) return n;
  var t = i.o().ht();
  for (var _r in t) n[_r] = y(t, _r);
  return n;
}